export default "__VITE_PUBLIC_ASSET__f49bb8be__"